import * as Yup from "yup";

export const AddFolderSchema = Yup.object().shape({

    folder_name: Yup.string().required("Enter Folder Name"),
    folder_desc: Yup.string().required("Enter Folder Description"),
})

